import * as React from 'react'
import ReactPaginate from 'react-paginate'
import './styles.scss'

export interface PaginationProps {
  onPageChange: (data: { selected: number }) => void
  pageCount: number
  currentPage: number
}

interface LabelProps {
  hideLabel?: boolean
}

const NextLabel: React.FC<LabelProps> = (props: LabelProps) => {
  return (
    <div>
      {props.hideLabel ? '' : 'Next'}
      <span className='fa fa-chevron-right ml-2'></span>
    </div>
  )
}

const PrevLabel: React.FC<LabelProps> = (props: LabelProps) => {
  return (
    <div>
      <span className='fa fa-chevron-left mr-2'></span>
      {props.hideLabel ? '' : 'Previous'}
    </div>
  )
}

export default class AppPagination extends React.Component<PaginationProps, any> {
  render() {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      return (
        <ReactPaginate
          containerClassName={'app-pagination'}
          pageCount={this.props.pageCount}
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          forcePage={this.props.currentPage}
          onPageChange={this.props.onPageChange}
          activeClassName={'active-pagination'}
          pageClassName={'app-pagination__item'}
          previousLabel={<PrevLabel />}
          nextLabel={<NextLabel />}
        />
      )
    } else {
      return (
        <ReactPaginate
          containerClassName={'app-pagination'}
          pageCount={this.props.pageCount}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          forcePage={this.props.currentPage}
          onPageChange={this.props.onPageChange}
          activeClassName={'active-pagination'}
          pageClassName={'app-pagination__item'}
          previousLabel={<PrevLabel hideLabel />}
          nextLabel={<NextLabel hideLabel />}
        />
      )
    }
  }
}
